import { makeStyles } from "tss-react/mui";

export const useStyles = makeStyles()((theme) => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        padding: '6px',
        justifyContent: 'center',
        alignItems: 'center',
    }
}))